import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { AnchorLink } from 'gatsby-plugin-anchor-links'

interface Datas {
  flamelinkHeroContent: {
    slug: string
    logotitle: string
    logoalt: string
    logowidth: number
    logoheight: number
    logoimage: {
      url: string
    }[]
  }
}

interface Filters {
  filters: boolean
}

const s = {
  container: `relative z-20 w-48 -ml-4 flex items-center 
  transition-all delay-300 ease-in-out duration-500`,
  flex: `flex items-center`,
  link: `uppercase font-sub font-bold text-h3 text-white`,
  image: `w-24 h-24 mr-0 filtercolor`,

  group: `w-fit-content h-fit-content`,
  title: (filters: any) => ` ${filters ? `invert` : `invert-0`} mb-0 -ml-1`,
  line: `w-full h-1 -mt-1 bg-impred`,
}

const Logo = ({ filters }: Filters) => {
  const datas = useStaticQuery(graphql`
    query {
      flamelinkHeroContent {
        slug
        logotitle
        logoalt
        logowidth
        logoheight
        logoimage {
          url
        }
      }
    }
  `) as Datas

  const { slug, logotitle, logoalt, logowidth, logoheight, logoimage } =
    datas.flamelinkHeroContent

  return (
    <div className={`${s.container} `}>
      <AnchorLink to={`/#${slug}`} stripHash className={s.link}>
        <div className={s.flex}>
          <img
            className={s.image}
            src={logoimage[0].url}
            alt={logoalt}
            width={logowidth}
            height={logoheight}
          />
          <div className={s.group}>
            <h3 className={s.title(filters)}>{logotitle}</h3>
            <div className={s.line} />
          </div>
        </div>
      </AnchorLink>
    </div>
  )
}

export default Logo
